import { ManualBillingAddress } from "../types/ManualStreetAddress";

export const EMPTY_MANUAL_BILLING_ADDRESS: ManualBillingAddress = {
  addressString: "",
  suburb: "",
  city: "",
  postcode: "",
};
